var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "position-relative",
      class: {
        "object-container-automation": !_vm.onProperties,
        "object-active":
          _vm.blockActive ||
          (!_vm.onProperties && _vm.id === _vm.propertiesIDBlock),
        "object-disabled": !_vm.onProperties && _vm.isDisableBlock
      },
      staticStyle: { cursor: "default" },
      on: { mouseover: _vm.pauseZoom, mouseleave: _vm.resumeZoom }
    },
    [
      _vm.onProperties
        ? _c(
            "div",
            {
              staticClass: "toggle-disable-block",
              staticStyle: { top: "-32px" }
            },
            [
              _c("j-switch", {
                model: {
                  value: _vm.disable_block,
                  callback: function($$v) {
                    _vm.disable_block = $$v
                  },
                  expression: "disable_block"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "tooltip-toggle-disable" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.disable_block ? "Disable" : "Enable") +
                    " this block\n    "
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.onProperties
        ? [
            _c("img", {
              staticClass: "icon-drag",
              attrs: { src: require("@/assets/new-form-ui/dragged.svg") }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "m__r--5",
              attrs: {
                src: require("@/assets/automation/while.svg"),
                width: "20",
                height: "20"
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "title-automation m__r--5" }, [
              _vm._v("WHILE")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "id-block-automation" }, [
              _vm._v(_vm._s(_vm.dataEdit ? "#" + _vm.dataEdit.id : ""))
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.onProperties
        ? _c("img", {
            staticClass: "pull-right cursor-pointer",
            attrs: {
              src: require("@/assets/automation/config.svg"),
              width: "20",
              height: "20"
            },
            on: { click: _vm.showProperties }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.onProperties
        ? _c(
            "div",
            [
              _c(
                "b-form-group",
                {
                  class: {
                    "error-input": _vm.$v.data_while.variable_source.$error
                  }
                },
                [
                  _c("label", [_vm._v(" Variable Source ")]),
                  _vm._v(" "),
                  _c("j-input", {
                    attrs: {
                      "error-required":
                        _vm.$v.data_while.variable_source.$error,
                      "max-length": 255,
                      placeholder: "Variable Source"
                    },
                    model: {
                      value: _vm.$v.data_while.variable_source.$model,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.$v.data_while.variable_source,
                          "$model",
                          $$v
                        )
                      },
                      expression: "$v.data_while.variable_source.$model"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("span", { staticClass: "title-automation" }, [
                _vm._v("Container")
              ]),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  class: {
                    "error-input": _vm.$v.data_while.variable_name.$error
                  }
                },
                [
                  _c("label", [_vm._v(" Variable Name ")]),
                  _vm._v(" "),
                  _c("j-input", {
                    attrs: {
                      "error-required": _vm.$v.data_while.variable_name.$error,
                      "max-length": 255,
                      placeholder: "Variable Name"
                    },
                    model: {
                      value: _vm.$v.data_while.variable_name.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.data_while.variable_name, "$model", $$v)
                      },
                      expression: "$v.data_while.variable_name.$model"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _c("div", [
            _c(
              "div",
              { staticClass: "trigger__label-variable ellipsis m__t--10" },
              [
                _c("img", {
                  staticClass: "m__r--10",
                  attrs: {
                    src: require("@/assets/automation/variable.png"),
                    width: "20",
                    height: "20"
                  }
                }),
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.dataEdit ? _vm.dataEdit.container_variable : ""
                    ) +
                    "\n    "
                )
              ]
            )
          ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-765504ff", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-765504ff","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/visual-programming/jVPBlockWhile.vue
// module id = null
// module chunks = 